{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": " حفظ {highestYearlyDiscount}%)",
    "{amount} days free": "أيام مجانية {amount}",
    "{amount} off": "{amount} خصم ",
    "{amount} off for first {number} months.": "شهور {number} لأول {amount} خصم",
    "{amount} off for first {period}.": ".{period} لأول{amount} خصم  ",
    "{amount} off forever.": "تخفيض {amount} مدى الحياة",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_zero": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% خصم",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "الإخبارية {newsletterName} بعد الآن نشرة {memberEmail} لن يتلقى ",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": ".بعد الآن رسائل بريد إلكتروني عندما يرد أحد على تعليقاتك {memberEmail} لم يتلقى",
    "{memberEmail} will no longer receive this newsletter.": ".بعد الآن هذه النشرة الإخبارية {memberEmail} لن يتلقى ",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} أيام مجانية",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "الحساب",
    "Account details updated successfully": ".تم تحديث تفاصيل الحساب بنجاح",
    "Account settings": "إعدادات الحساب",
    "Add a personal note": "أضف ملحوظة شخصية",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": ".بعد انتهاء فترة التجربة المجانية، سيتم خصم السعر العادي للفئة التي اخترتها. يمكنك دائمًا إلغاء الاشتراك قبل ذلك",
    "Already a member?": "هل أنت عضو بالفعل؟",
    "An error occurred": "حدث خطأ",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى أو <a>الاتصال بالدعم</a> إذا استمر الخطأ.",
    "Back": "الرجوع",
    "Back to Log in": "الرجوع الى تسجيل الدخول",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "مثال: الجمعة البيضاء",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "إلغاء في أي وقت",
    "Cancel subscription": "إلغاء الاشتراك",
    "Canceled": "",
    "Cancellation reason": "سبب الإلغاء",
    "Change": "تغيير",
    "Change plan": "تغيير الخطة",
    "Check spam & promotions folders": "تحقق من مجلدات البريد المزعج والعروض",
    "Check with your mail provider": "تحقق من مزود خدمة البريد الإلكتروني الخاص بك",
    "Check your inbox to verify email update": "تحقق من صندوق الوارد الخاص بك لتأكيد تحديث البريد الإلكتروني",
    "Choose": "اختر",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "اختر خطة مختلفة",
    "Choose a plan": "اختر خطة",
    "Choose a tier": "",
    "Choose an option": "",
    "Choose your newsletters": "اختر نشرتك الإخبارية المفضلة",
    "City": "",
    "Click here to retry": "انقر هنا لإعادة المحاولة",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "إغلاق",
    "Code": "كود",
    "Comment preferences updated.": "تم تعديل تفضيلات التعليقات.",
    "Comments": "تعليقات",
    "Complimentary": "مجانًا",
    "Confirm": "تأكيد",
    "Confirm cancellation": "تأكيد الإلغاء",
    "Confirm subscription": "تأكيد الاشتراك",
    "Contact support": "الاتصال بالدعم",
    "Continue": "استمرار",
    "Continue subscription": "متابعة الاشتراك",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Stripe تعذر إنشاء جلسة دفع ",
    "Could not sign in. Login link expired.": ".تعذر تسجيل الدخول. رابط تسجيل الدخول منتهي الصلاحية",
    "Could not update email! Invalid link.": ".تعذر تحديث البريد الإلكتروني! الرابط غير صالح",
    "Country": "",
    "Create a new contact": "إنشاء جهة اتصال جديدة",
    "Current plan": "الخطة الحالية",
    "Delete account": "حذف الحساب",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "لم تكن تقصد القيام بذلك؟ إدارة تفضيلاتك <button>هنا</button>.",
    "Don't have an account?": "ليس لديك حساب؟",
    "Edit": "تعديل",
    "Email": "البريد الإلكتروني",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "النشرة الإخبارية عبر البريد الإلكتروني",
    "Email newsletter settings updated": "تم تحديث إعدادات النشرة الإخبارية عبر البريد الإلكتروني",
    "Email preferences": "تفضيلات البريد الإلكتروني",
    "Email preferences updated.": "تم تعديل تفضيلات البريد الإلكتروني.",
    "Emails": "رسائل البريد الإلكتروني",
    "Emails disabled": "تم تعطيل جميع رسائل البريد الإلكتروني",
    "Ends {offerEndDate}": "{offerEndDate} ينتهي في ",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "أدخل الكود",
    "Enter the recipient's email address": "",
    "Enter your email address": "أدخل عنوان بريدك الإلكتروني",
    "Enter your name": "أدخل اسمك",
    "Error": "خطأ",
    "Expires {expiryDate}": "{expiryDate} ينتهي في ",
    "Facebook": "",
    "Failed to cancel subscription, please try again": ".فشل في إلغاء الاشتراك، يرجى المحاولة مرة أخرى",
    "Failed to log in, please try again": ".فشل في تسجيل الدخول، يرجى المحاولة مرة أخرى",
    "Failed to log out, please try again": ".فشل في تسجيل الخروج، يرجى المحاولة مرة أخرى",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": ".فشل في معالجة عملية الدفع، يرجى المحاولة مرة أخرى",
    "Failed to send magic link email": "فشل في إرسال بريد رابط التسجيل السحري",
    "Failed to send verification email": "فشل في إرسال بريد التحقق",
    "Failed to sign up, please try again": "فشل في التسجيل، يرجى المحاولة مرة",
    "Failed to update account data": "فشل في تحديث بيانات الحساب",
    "Failed to update account details": "فشل في تحديث تفاصيل الحساب",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "فشل في تحديث إعدادات النشرة الإخبارية",
    "Failed to update subscription, please try again": "فشل في تحديث الاشتراك، يرجى المحاولة مرة أخرى",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "إلى الأبد",
    "Free Trial – Ends {trialEnd}": " {trialEnd} التجربة المجانية - تنتهي في ",
    "From": "",
    "Get help": "احصل على مساعدة",
    "Get in touch for help": "تواصل للحصول على مساعدة",
    "Get notified when someone replies to your comment": "احصل على اشعار عندما يتم الرد على تعليقك",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "شارك رأيك في هذا المنشور",
    "Help! I'm not receiving emails": "مساعدة! أنا لا أتلقى الرسائل الإلكترونية",
    "Here are a few other sites you may enjoy.": "إليك بعض المواقع الأخرى التي قد تعجبك",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": ".إذا تم تصنيف النشرة الإخبارية كبريد مزعج، يتم تعطيل الرسائل الإلكترونية تلقائيًا لهذا العنوان للتأكد من إنك لن تتلقىأي رسائل غير مرغوب فيها",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": ".إذا كانت الشكوى من البريد المزعج غير مقصودة،أو إذا كنت ترغب في بدء تلقي الرسائل الإلكترونية مرة أخرى، يمكنك إعادة الاشتراك في الرسائل الإلكترونية بالنقر على الزر في الشاشة السابقة ",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "{periodEnd} إذا قمت بإلغاء اشتراكك الآن، ستظل لديك إمكانية الوصول حتى ",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "{senderEmail} إذا كان لديك حساب بريد إلكتروني تابع لشركة أو حكومة، تواصل مع قسم تكنولوجيا المعلومات واطلب منهم السماح بتلقي الرسائل من",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": ".تم إرسال رابط تسجيل الدخول إلى صندوق الوارد الخاص بك. إذا لم يصلك في غضون ٣ دقائق، تأكد من التحقق من مجلد البريد المزعج",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "تم إرسال بريد إلكتروني إلى {submittedEmailOrInbox}. اضغط على اللينك أو أدخل الكود هنا",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": ".إذا كنت ترغب في بدء تلقي الرسائل الإلكترونية مرة أخرى، أفضل الخطوات التالية هي التحقق من عنوان بريدك الإلكتروني المسجل لأي مشاكل ثم النقر على زر إعادة الاشتراك في الشاشة السابقة",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": ".إذا كنت لا تتلقى النشرة الإخبارية التي اشتركت فيها، إليك بعض الأمور التي يجب التحقق منها ",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": ".{supportAddress} إذا كنت قد أتممت جميع هذه الفحوصات وما زلت لا تتلقى الرسائل الإلكترونية، يمكنك التواصل للحصول على الدعم عن طريق الاتصال بـ",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "في حالة تلقي فشل دائم عند محاولة إرسال نشرة إخبارية، سيتم تعطيل الرسائل الإلكترونية على الحساب",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": ".إلى قائمة جهات الاتصال الخاصة بك. هذا يخبر مزود خدمة البريد الإلكتروني أن الرسائل المرسلة من هذا العنوان يجب أن تعتبر موثوقة{senderEmail} في تطبيق البريد الإلكتروني الخاص بك، أضف",
    "Invalid email address": ".عنوان البريد الإلكتروني غير صالح",
    "Invalid verification code": "",
    "Jamie Larson": "فلان الفلاني",
    "jamie@example.com": "folan@mesal.com",
    "Less like this": "أقل من هذا",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": ".(تأكد من أن الرسائل الإلكترونية لا تنتهي في مجلدات البريد المزعج أو العروض في صندوق الوارد الخاص بك عن طريق الخطأ. إذا كانت كذلك (انقر على علامة كغير مزعج) و/أو (نقل إلى صندوق الوارد",
    "Manage": "إدارة",
    "Maybe later": "ربما لاحقًا",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": ".العضويات غير متاحة، يرجى الاتصال بالمالك للحصول على الوصول",
    "month": "شهر",
    "Monthly": "شهري",
    "More like this": "المزيد من هذا",
    "More options": "",
    "Name": "الاسم",
    "Need more help? Contact support": "تحتاج إلى المزيد من المساعدة؟ اتصل بالدعم",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": ".(bounce) يمكن تعطيل النشرات الإخبارية على حسابك لسببين: تم تصنيف بريد إلكتروني سابق كرسالة غير مرغوب فيها، أو محاولة إرسال بريدإلكترونى أدى إلى فشل دائم",
    "No member exists with this e-mail address.": ".لا يوجد عضو بهذا عنوان البريد الإلكتروني",
    "No options found": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "لا تتلقى رسائل البريد الإلكتروني؟",
    "Now": "",
    "Now check your email!": "!الآن تحقق من بريدك الإلكتروني!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": ".بمجرد إعادة الاشتراك، إذا كنت لا تزال لا ترى الرسائل في صندوق الوارد الخاص بك تحقق من مجلد البريد المزعج. بعض مزودي الخدمة يحتفظون بسجل للشكاوى السابقة المتعلقة بالبريد المزعج وسوف يستمرون في وضع العلامات على الرسائل. إذا حدث ذلك، قم بوضع علامة على النشرة الإخبارية الأخيرة كـ (ليس بريدًا مزعجًا) لإعادتها إلى صندوق الوارد الرئيسي",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "(bounce)فشل دائم ",
    "Phone number": "رقم الهاتف",
    "Plan": "الخطة",
    "Plan checkout was cancelled.": ".تم إلغاء إتمام عملية الدفع للخطة",
    "Plan upgrade was cancelled.": ".تم إلغاء ترقية الخطة",
    "Please contact {supportAddress} to adjust your complimentary subscription.": ".لتعديل اشتراكك المجاني {supportAddress} يرجى الاتصال ب ",
    "Please enter {fieldName}": "{fieldName} يرجى إدخال ",
    "Please fill in required fields": "يرجى ملء الحقول المطلوبة",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "إعادة تفعيل رسائل البريد الالكتروني",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "التوصيات",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Remove {option}": "",
    "Renews at {price}.": "{price} سيتم التجديد بسعر ",
    "Resume subscription": "",
    "Retry": "اعد المحاولة",
    "Save": "حفظ",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "",
    "Sending...": "...جاري الإرسال",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "عرض الكل",
    "Sign in": "تسجيل الدخول",
    "Sign out": "تسجيل الخروج",
    "Sign up": "إنشاء حساب",
    "Signup error: Invalid link": "خطأ في التسجيل: الرابط غير صالح",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": ".حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": ".عذرًا، لا توجد توصيات متاحة حاليًا",
    "Sorry, that didn’t work.": ".عذرًا، لم ينجح ذلك",
    "Spam complaints": "شكاوى البريد المزعج",
    "Start {amount}-day free trial": "يوم {amount} ابدأ تجربة مجانية لمدة ",
    "Starting {startDate}": "{startDate} ابتداًء من ",
    "Starting today": "ابتداًء من اليوم",
    "State": "",
    "Submit feedback": "إرسال رأيك",
    "Subscribe": "اشترك",
    "Subscribed": "تم الاشتراك بنجاح",
    "Subscription plan updated successfully": "تم تحديث خطة الاشتراك بنجاح",
    "Success": "تم بنجاح",
    "Success! Check your email for magic link to sign-in.": ".تم بنجاح! تحقق من بريدك الالكتروني للحصول على رابط تسجيل الدخول السحري",
    "Success! Your account is fully activated, you now have access to all content.": ".تم بنجاح! حسابك مفعل بالفعل، لديك الآن وصول إلى جميع المحتويات",
    "Success! Your email is updated.": "تم بنجاح! تم تحديث بريدك الالكتروني",
    "Successfully unsubscribed": "تم الغاء الاشتراك بنجاح",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": ".شكرًا على اشتراكك. قبل أن تبدأ في القراءة، إليك بعض المواقع الأخرى التي قد تستمع بها",
    "Thank you for your support": "شكرًا لك على دعمك",
    "Thank you for your support!": "!شكرًا لك على دعمك",
    "Thanks for the feedback!": "شكرا لمشاركتك رأيك!",
    "That didn't go to plan": "لم تسر الامور على ما يرام",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "عنوان البريد الالكتروني الذي نملكه لك هو {memberEmail} — إذا لم يكن صحيحًا، يمكنك تحديثه في <button>منطقة إعدادات الحساب</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "",
    "There was an error cancelling your subscription, please try again.": ".حدث خطأ أثناء إلغاء الاشتراك، يرجى المحاولة مرة أخرى",
    "There was an error continuing your subscription, please try again.": ".حدث خطأ أثناء الاشتراك، يرجى المحاولة مرة أخرى",
    "There was an error processing your payment. Please try again.": ".حدث خطأ أثناء معالجة دفعك، يرجى المحاولة مرة أخرى",
    "There was an error sending the email, please try again": ".حدث خطأ أثناء إرسال البريد الاكتروني، يرجى المحاولة مرة أخرى",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "هذا الموقع للمشتركين فقط، تواصل مع ادارة الموقع للحصول على اشتراك.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "هذا الموقع لا يقبل المدفوعات في الوقت الحالي",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "لاكمال انشاء حسابك، استخدم رابط التأكيد المرسل الى بريد. اذا لم تتلقى الرسالة خلال 3 دقائق، برجاء التأكد من مجلد المهملات.",
    "To continue to stay up to date, subscribe to {publication} below.": ".أدناه {publication} للاستمرار في متابعة أخر التحديثات، اشترك في ",
    "Too many attempts try again in {number} days.": ".أيام{number} محاولات متعددة جدًا، حاول مرة أخرى بعد ",
    "Too many attempts try again in {number} hours.": ".ساعات {number} محاولات متعددة جدًا، حاول مرة أخرى بعد",
    "Too many attempts try again in {number} minutes.": ".دقيقة {number} محاولات متعددة جدًا، حاول مرة أخرى بعد ",
    "Too many different sign-in attempts, try again in {number} days": ".أيام{number} محاولات تسجيل الدخول متعددة جدًا، حاول مرة أخري بعد ",
    "Too many different sign-in attempts, try again in {number} hours": ".ساعة {number} محاولات تسجيل الدخول متعددة جدًا، حاول مرة أخري بعد ",
    "Too many different sign-in attempts, try again in {number} minutes": ".دقيقة {number} محاولات تسجيل الدخول متعددة جدًا، حاول مرة أخري بعد ",
    "Too many sign-up attempts, try again later": "ًمحاولات اشتراك متعددة جدًا، حاول مرة أخرى لاحقا",
    "Try free for {amount} days, then {originalPrice}.": "  .{originalPrice} يوما، ثم  {amount} جرب مجانًا لمدة",
    "Unable to initiate checkout session": "غير قادر على بدء جلسة الدفع",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": ".افتح الوصول إلي جميع النشرات الإخبارية من خلال الاشتراك المدفوع",
    "Unsubscribe from all emails": "إلغاء الاشتراك من جميع الالكترونية",
    "Unsubscribed": "تم إلغاءاشتراكك",
    "Unsubscribed from all emails.": "تم إلغاء اشتراكك من جميع الرسائل الاكترونية",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "الغاء اشتراك من الرسائل لا يعني إلغاء اشتراكك المدفوع في {title}",
    "Update": "تحديث",
    "Update your preferences": "تحديث تفضيلاتك",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "تم إرسال رابط التحقق، يرجى التحقق من صندوق الوارد لديك",
    "Verify your email address is correct": "تحقق من صحة عنوان بريدك الاكتروني",
    "Verifying...": "جارٍ التحقيق ...",
    "View plans": "عرض الخطط",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "لم نتمكن من إلغاء اشتراكك في الرسائل لانه لم يتم العثور على بريدك الاكتروني. برجاء التواصل مع ادارة الموقع.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "!{name} ،مرحبًا بعودتك",
    "Welcome back!": "!مرحبًا بعودتك",
    "Welcome to {siteTitle}": "{siteTitle} مرحبًا بك في ",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "عندما يفشل صندوق الوارد في استقبال رسالة بريد إلكتروني، يُطلق على ذلك عادةً ارتداد. في كثير من الحالات، قد يكون هذا الارتداد مؤقتًا. ومع ذلك، في بعض الحالات، قد يتم إرجاع البريد الإلكتروني كفشل دائم إذا كان عنوان البريد الإلكتروني غير صالح أو غير موجود.",
    "Why has my email been disabled?": "لماذا تم تعطيل بريدي الالكتروني؟",
    "X (Twitter)": "",
    "year": "سنة",
    "Yearly": "سنوي",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "لديك حاليًا عضوية مجانية، قم بالترقية إلى اشتراك مدفوع للحصول على وصول كامل",
    "You have been successfully resubscribed": "تم اعادة اشتراكك بنجاح",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "أنت لا تتلقي رسائل بريد إلكتروني حاليًا",
    "You're not receiving emails": "لم تستلم رسالة بريدية",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "لم تستلم رسالة بريدية لربما انك جعلت الرسائل مهملة او ان الرسائل لا تصل الى بريدك الذي سجلته.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_zero": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_zero": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": ".تم تسجيل الدخول بنجاح",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "تم الاشتراك بنجاح في <strong>{siteTitle}</strong>",
    "Your account": "حسابك",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "بريدك الاكتروني لم ينجح في إعادة الاشتراك، رجاء المحاولة مرة أخرى",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "بريدك الوارد",
    "Your input helps shape what gets published.": "آرائك تساهم في تحسين ما ينشر.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "{expiryDate} اشتراكك سوف ينتهي في",
    "Your subscription will renew on {renewalDate}": "{renewalDate} اشتراكك سوف يتجدد في",
    "Your subscription will start on {subscriptionStart}": "{subscriptionStart} اشتراك سوف يبدأ في"
}
